var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var pad2 = function (n) { return ("0" + n).slice(-2); };
/** "11/08/2026" */
var formatDate = function (iso) {
    if (!iso)
        return undefined;
    var d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return undefined;
    return "".concat(pad2(d.getDate()), "/").concat(pad2(d.getMonth() + 1), "/").concat(d.getFullYear());
};
/** "16:32:15" */
var formatTime = function (iso) {
    if (!iso)
        return undefined;
    var d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return undefined;
    return "".concat(pad2(d.getHours()), ":").concat(pad2(d.getMinutes()), ":").concat(pad2(d.getSeconds()));
};
/**
 * Tipo de punto en la línea de tiempo. El backend puede agregar acciones nuevas,
 * así que se deduce por patrón sobre la acción técnica y su etiqueta.
 */
var traceStatus = function (action, actionLabel) {
    var key = "".concat(action !== null && action !== void 0 ? action : "", " ").concat(actionLabel !== null && actionLabel !== void 0 ? actionLabel : "").toUpperCase();
    if (/FAIL|ERROR|FALLID|RECHAZ/.test(key))
        return "error";
    if (/SUCCESS|SENT|EXITOS|ENVIADO/.test(key))
        return "success";
    if (/START|INIT|INICIO/.test(key))
        return "start";
    if (/FINISH|END|FIN /.test(key))
        return "end";
    return "step";
};
var attachmentLabel = function (attachment) { return (attachment === null || attachment === void 0 ? void 0 : attachment.documentLabel) || (attachment === null || attachment === void 0 ? void 0 : attachment.filename) || ""; };
var originLabel = function (sendType) {
    if (!sendType)
        return undefined;
    if (sendType.toUpperCase() === "MANUAL")
        return "Manual";
    if (sendType.toUpperCase() === "AUTOMATIC")
        return "Automático";
    return sendType;
};
/** Observación del paso, completada con el detalle propio de cada acción */
var stepObservation = function (entry) {
    var _a, _b;
    var data = (_a = entry.data) !== null && _a !== void 0 ? _a : {};
    var parts = [];
    if (data.observation)
        parts.push(data.observation);
    // Resumen final: los documentos realmente enviados
    var attachments = ((_b = data.attachments) !== null && _b !== void 0 ? _b : [])
        .map(attachmentLabel)
        .filter(Boolean);
    if (attachments.length > 0) {
        parts.push("Documentos enviados: ".concat(attachments.join(", ")));
    }
    // Documento de ese paso puntual, si el backend no envió observación
    if (parts.length === 0) {
        var single = attachmentLabel(data.attachment);
        if (single)
            parts.push("Documento adjunto: ".concat(single));
    }
    return parts.length > 0 ? parts.join(" · ") : undefined;
};
/** Cantidad de documentos del envío: el resumen final manda; si no, se cuentan los adjuntados */
var documentsCount = function (entries) {
    var _a, _b;
    var summary = entries.find(function (entry) { var _a, _b; return ((_b = (_a = entry.data) === null || _a === void 0 ? void 0 : _a.attachments) !== null && _b !== void 0 ? _b : []).length > 0; });
    if (summary)
        return (_b = (_a = summary.data) === null || _a === void 0 ? void 0 : _a.attachments) === null || _b === void 0 ? void 0 : _b.length;
    var attached = entries.filter(function (entry) { var _a, _b; return ((_a = entry.data) === null || _a === void 0 ? void 0 : _a.action) === "DOCUMENT_ATTACHED" || !!((_b = entry.data) === null || _b === void 0 ? void 0 : _b.attachment); }).length;
    return attached > 0 ? attached : undefined;
};
/** Primer valor no vacío del envío, ya que solo algunos pasos traen el dato */
var firstValue = function (entries, pick) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var entry = entries_1[_i];
        var value = pick(entry);
        if (value)
            return value;
    }
    return undefined;
};
/** Correos en copia del envío (la lista llega repetida en cada paso) */
var ccEmails = function (entries) {
    var _a, _b;
    var found = entries.find(function (entry) { var _a, _b; return ((_b = (_a = entry.data) === null || _a === void 0 ? void 0 : _a.ccEmail) !== null && _b !== void 0 ? _b : []).length > 0; });
    return (_b = (_a = found === null || found === void 0 ? void 0 : found.data) === null || _a === void 0 ? void 0 : _a.ccEmail) !== null && _b !== void 0 ? _b : [];
};
/** Agrupa por correlationId: cada grupo es un envío completo con su traza */
var groupByCorrelation = function (entries) {
    var groups = new Map();
    entries.forEach(function (entry) {
        var _a;
        var key = ((_a = entry.data) === null || _a === void 0 ? void 0 : _a.correlationId) || entry.id;
        var group = groups.get(key);
        if (group)
            group.push(entry);
        else
            groups.set(key, [entry]);
    });
    return Array.from(groups.values());
};
var buildTrace = function (entries) {
    var _a, _b;
    var trace = entries.map(function (entry) {
        var _a, _b;
        return ({
            time: formatTime(entry.createdAt),
            action: entry.actionLabel || ((_a = entry.data) === null || _a === void 0 ? void 0 : _a.action) || "Acción del envío",
            observation: stepObservation(entry),
            status: traceStatus((_b = entry.data) === null || _b === void 0 ? void 0 : _b.action, entry.actionLabel),
        });
    });
    // El componente no tiene columna de copias: se muestran como un paso de la traza,
    // que es también lo que se exporta al Excel.
    var cc = ccEmails(entries);
    if (cc.length > 0) {
        var insertAt = ((_a = trace[0]) === null || _a === void 0 ? void 0 : _a.status) === "start" ? 1 : 0;
        trace.splice(insertAt, 0, {
            time: (_b = trace[0]) === null || _b === void 0 ? void 0 : _b.time,
            action: "Correos en copia (CC)",
            observation: cc.join(", "),
        });
    }
    return trace;
};
var buildItem = function (entries) {
    var _a;
    /** Los pasos se muestran en el orden en que ocurrieron */
    var steps = __spreadArray([], entries, true).sort(function (a, b) { return Date.parse(a.createdAt) - Date.parse(b.createdAt); });
    var first = steps[0];
    var trace = buildTrace(steps);
    var hasError = trace.some(function (step) { return step.status === "error"; });
    var hasFinished = trace.some(function (step) { return step.status === "success" || step.status === "end"; });
    var email = firstValue(steps, function (entry) { var _a; return entry.email || ((_a = entry.data) === null || _a === void 0 ? void 0 : _a.email); });
    var cc = ccEmails(steps);
    var sendType = firstValue(steps, function (entry) { var _a; return (_a = entry.data) === null || _a === void 0 ? void 0 : _a.sendType; });
    var trigger = firstValue(steps, function (entry) { var _a; return (_a = entry.data) === null || _a === void 0 ? void 0 : _a.triggerDescription; });
    return {
        id: ((_a = first.data) === null || _a === void 0 ? void 0 : _a.correlationId) || first.id,
        date: formatDate(first.createdAt),
        time: formatTime(first.createdAt),
        sentAt: first.createdAt,
        userCode: firstValue(steps, function (entry) { var _a; return (_a = entry.data) === null || _a === void 0 ? void 0 : _a.actorUserCode; }),
        userName: firstValue(steps, function (entry) { var _a; return (_a = entry.data) === null || _a === void 0 ? void 0 : _a.actorUserName; }),
        email: cc.length > 0 ? "".concat(email !== null && email !== void 0 ? email : "", " (+").concat(cc.length, " en copia)") : email,
        origin: originLabel(sendType),
        originDetail: (sendType === null || sendType === void 0 ? void 0 : sendType.toUpperCase()) === "AUTOMATIC" ? trigger : undefined,
        documentsCount: documentsCount(steps),
        result: hasError ? "Fallido" : hasFinished ? "Exitoso" : undefined,
        trace: trace,
    };
};
/**
 * Convierte la bitácora plana del servicio de notificaciones (una entrada por acción)
 * en los envíos que muestra el tab "Historial de correos", del más reciente al más antiguo.
 */
export var mapEmailSendLogToMailHistory = function (entries) {
    return groupByCorrelation(entries)
        .map(buildItem)
        .sort(function (a, b) { var _a, _b; return Date.parse((_a = b.sentAt) !== null && _a !== void 0 ? _a : "") - Date.parse((_b = a.sentAt) !== null && _b !== void 0 ? _b : ""); });
};
/** Número de certificado que reporta la bitácora, para el encabezado de la exportación */
export var certificateFromEmailSendLog = function (entries) {
    return firstValue(entries, function (entry) { var _a; return (_a = entry.data) === null || _a === void 0 ? void 0 : _a.certificateNumber; });
};
